import React, { useState, useEffect, useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getList } from "actions/chargers/station/actions";
import Filers from "../filters";
import MapComponent from "./googleMap";
import SingleInfo from "../single/info";
import { stateColor } from "./map-filter-items";
import {
  brokenColor,
  lostColor,
  pausedColor,
  technicalCheckupColor
} from "../../../scooter/scooter/hot-map/map-filter-items";
import { ADMIN_ACTIONS } from "../../constants";
import { getSavedFilters } from "../../../../lib/HOC/withFilters";

const FILTERS_KEY = "stationMap";

const ChargerStationsMap = ({
                              getList,
                              list,
                              openCustomModal,
                              closeCustomModal
                            }) => {
  const [selected, setSelected] = useState(null);
  const [filters, setFilters] = useState(getSavedFilters(FILTERS_KEY));

  const startListGetter = useCallback(() => {
      getList(filters);
    },
    [getList, filters]);

  const handleSearch = (filters) => {
    setFilters(filters);
  };

  const handleReset = () => {
    setFilters({});
  };

  const getInfoWrapper = () => (
    <div className="p-2">
      {`All: ${list.length}`}
      <hr className="mt-1 mb-1"/>

      <div className="form-check d-flex align-items-center justify-content-between">
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Active: ${list.filter(item => item.status === "ACTIVE").length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": stateColor }}/>
      </div>
      <div className="form-check d-flex align-items-center justify-content-between">
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Not Active: ${list.filter(item => item.status !== ADMIN_ACTIONS.ACTIVE).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": pausedColor }}/>
      </div>
      <div className="form-check d-flex align-items-center justify-content-between">
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Technical Checkup: ${list.filter(item => item.status === ADMIN_ACTIONS.TECHNICAL_CHECKUP).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": technicalCheckupColor }}/>
      </div>
      <div className="form-check d-flex align-items-center justify-content-between">
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Broken: ${list.filter(item => item.status === ADMIN_ACTIONS.BROKEN).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": brokenColor }}/>
      </div>
      <div className="form-check d-flex align-items-center justify-content-between">
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Lost: ${list.filter(item => item.status === ADMIN_ACTIONS.LOST).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": lostColor }}/>
      </div>
    </div>
  );

  const handleOpen = (value) => {
    // [original.located.longitude, original.located.latitude]
    const { location } = value;
    if (!location) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    setSelected(value.id);

    const modalObj = {
      id: "charger-history-position",
      modalSettings: {
        size: "sm",
        style: {
          width: 500
        }
      },
      header: "Charger Info",
      children: (
        <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
          <SingleInfo
            value={value}
          />
        </React.Suspense>
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  useEffect(() => {
    startListGetter();
  }, [startListGetter]);

  return (
    <div className="w-100 h-100 p-2 position-relative">
      <div className="filters">
        <Filers
          name={FILTERS_KEY}
          activeFilters={filters}
          totalCount={list.length}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>

      <div style={{
        height: "calc(100vh - 140px)"
      }}>
        <MapComponent
          center={{
            lat: 40.1870293,
            lng: 44.5129457
          }}
          zoom={12}
          markers={list}
          handleShowInfo={getInfoWrapper}
          showPositionFromMap={handleOpen}
          selectedId={selected}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.chargerStation.list.content ? state.chargerStation.list.content : [],
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ChargerStationsMap);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/map/index.js